<template>
  <div
    :class="{ 'alert--error': isError }"
    class="alert"
  >
    <div class="alert__content alert-content">
      <component
        v-if="isShowIcon"
        :is="iconComponent"
        class="alert-content__icon"
      />
      <p
        :class="{ 'alert-content__text--error': isError }"
        class="alert-content__text"
        v-html="message"
      ></p>
      <button-close
        :class="{ 'alert-content__button--error': isError }"
        class="alert-content__button"
        @click="$emit('close', id)"
      />
    </div>
  </div>
</template>

<script>
import { ALERT_TYPES, alertProps } from '@/mikan/_shared/lib/plugins/AlertBox/vueTypes';
import IconAlertSuccess from '@/mikan/_shared/components/atoms/icons/IconAlertSuccess.vue';
import IconAlertError from '@/mikan/_shared/components/atoms/icons/IconAlertError.vue';
import ButtonClose from '@/mikan/_shared/components/atoms/ButtonClose.vue';

export default {
  components: {
    ButtonClose,
  },
  props: alertProps,
  computed: {
    isShowIcon() {
      return this.type !== ALERT_TYPES.INFO;
    },
    isSuccess() {
      return this.type === ALERT_TYPES.SUCCESS;
    },
    isError() {
      return this.type === ALERT_TYPES.ERROR;
    },
    iconComponent() {
      if (this.isSuccess) {
        return IconAlertSuccess;
      } else if (this.isError) {
        return IconAlertError;
      }
      return undefined;
    },
  },
  mounted() {
    if (this.isError) {
      return;
    }
    const timerId = setTimeout(() => {
      this.$emit('close', this.id);
    }, 10000);
    this.$once('hook:beforeDestroy', () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    });
  },
};
</script>


<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';
@import '~@/mikan/_shared/base/mixins';

.alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-yuzu-light;
  @include for-tb-pc {
    min-width: $full-width;
    padding: 12px 0;
  }
  @include for-sp {
    padding: 18px 0;
  }

  &--error {
    background-color: $color-strawberry;
  }

  &__content {
    @include for-tb-pc {
      flex: 0 0 $full-width;
    }
    @include for-sp {
      flex: 1 1 auto;
    }
  }
}

.alert-content {
  display: flex;
  justify-content: space-between;
  @include for-tb-pc {
    align-items: center;
  }

  &__icon {
    flex: 0 0 auto;
    @include for-sp {
      margin-left: 8px;
    }
  }

  &__text {
    flex: 0 1 auto;
    color: $color-navy;
    font-size: 14px;

    &--error {
      color: $color-white;
    }

    &:nth-child(n + 2) {
      margin-left: 16px;
    }
  }

  &__button {
    flex: 0 0 auto;
    color: $color-navy-20;
    font-size: 16px;
    transition: color $transition-interaction;

    @include for-sp {
      margin-right: 8px;
    }

    &:hover {
      color: $color-navy-40;
    }

    &:active {
      color: $color-navy-10;
    }

    &:nth-child(n + 2) {
      margin-left: 16px;
    }

    &--error {
      // TODO: 他に赤地白ボタンのコンポーネントが出現したら色定数化する
      color: $color-white;

      &:hover {
        color: $color-white;
      }

      &:active {
        // TODO: 他に赤地白ボタンのコンポーネントが出現したら色定数化する
        color: lighten($color-strawberry, 10%);
      }
    }
  }
}
</style>
